


























































































































import { OperationBlockVue } from "fs-pb-vue2/vueModels/history/OperationBlockVue";
import { Component, Prop } from "vue-property-decorator";

@Component({})
export default class OperationBlock extends OperationBlockVue {
  @Prop() isCreditShedule!: boolean;
  @Prop() hideTime!: boolean;

  /**
  * Признак мобильного браузера
  */
  get isMobileBrowser(): boolean {
    const userAgent = navigator.userAgent;
    const mobileRegExp = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
    return mobileRegExp.test(userAgent);
  }

  get getWidthForSum(): string {
    if (this.mainSum.length) {
      const lengthSum: number = this.mainSum.replaceAll(' ', '').replaceAll('-', '').replaceAll(',', '').length;
      switch(lengthSum) {
        case 2:
          return 'min-width: 59px;';
        case 3:
          return 'min-width: 70px;';
        case 4:
          return 'min-width: 78px;';
        case 5:
          return 'min-width: 86px';
        case 6:
          return 'min-width: 97px;';
        case 7:
          return 'min-width: 105px;';
        case 8:
          return 'min-width: 113px;';
        default:
          return ''; 
      }
    }
    return '';
  }
}
